// T4 review round 2: one wording for City Operations panel errors, chosen by HTTP status.
export const PERMISSION_HINT = 'You need the ops:bulk permission to see this. Ask a super admin to grant it.';
export const TIMEOUT_HINT = 'The server took too long to answer — the recompute may still be running. Check again in a few minutes.';

export const opsErrorMessage = (e: any, fallback: string): string => {
    const status = e?.response?.status;
    if (status === 403) return PERMISSION_HINT;
    if (status === 504 || e?.code === 'ECONNABORTED' || /timeout/i.test(String(e?.message ?? ''))) return TIMEOUT_HINT;
    return e?.response?.data?.message || fallback;
};
